import React from "react"
import { PageRoute } from "../../../models";
import { Link } from "react-router-dom";
import { Badge } from "antd";
import styles from "./messagesLink.scss"
import { selectUnreadCount } from "../../../routes/Chat/chat.ducks";
import { selectSystemMessageUnreadCount } from "../../../routes/SystemMessage/systemMessage.ducks";
import { useSelector } from "react-redux";
import { MessagesIcon } from "./MessagesIcon";

export const MessagesLink = () => {
  const chatUnreadCount = useSelector(selectUnreadCount);
  const systemUnreadCount = useSelector(selectSystemMessageUnreadCount);
  const totalUnreadCount = (chatUnreadCount || 0) + (systemUnreadCount || 0);

  return (
    <span className={styles.messagesIconWrapper}>
      <Link to={PageRoute.chats} rel="noopener noreferrer nofollow">
        <Badge count={totalUnreadCount} style={{ top: 2 }}>
          <MessagesIcon />
        </Badge>
      </Link>
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/Header/MessagesLink/MessagesLink.tsx